<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <span class="headline font-weight-medium"
            >{{ nombre_mes.toUpperCase() }}, {{ anio }}</span
          >
        </v-col>
        <v-col cols="8" class="pt-1" v-if="cerrado == true">
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            :loading="is_download"
            @click="descargaReporte()"
            v-if="this.$hasPermision('planillas.download')"
          >
            Descargar XLS
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('planillas.cierra')"
            color="success"
            width="140"
            class="float-right"
            @click="calcularCerrarBtn"
            style="margin-right: 2%"
          >
            Calcular y Cerrar
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('planillas.guarda')"
            color="primary"
            width="140"
            class="float-right"
            @click="guardaCierraBtn"
            style="margin-right: 2%"
          >
            Guardar
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('planillas.actualiza')"
            color="dark"
            width="140"
            class="float-right"
            @click="actualizarBtn"
            style="margin-right: 2%"
          >
            Actualizar
          </v-btn>
        </v-col>
        <v-col cols="8" class="pt-1" v-else>
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            :loading="is_download"
            @click="descargaReporte()"
          >
            Descargar XLS
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('planillas.abre')"
            width="140"
            class="float-right"
            style="margin-right: 2%"
            @click="reabrirPlanillaBtn()"
          >
            Reabrir Planilla
          </v-btn>
        </v-col>
      </v-row>
      <!--<v-row>
                <v-col cols="4" class="pt-1">
                    <h1>Total De Planilla : {{total}}</h1>              
                </v-col>
                <v-col cols="2" class="pt-1">
                </v-col>
            </v-row>-->
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Detalle de Planilla
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="newArray"
              :search="search"
              height="57vh"
            >
              <template v-slot:item.empleado_apellidos="{ item }">
                <span style="width: 100%">{{ item.empleado_apellidos }}</span>
              </template>

              <template v-slot:item.empleado_nombres="{ item }">
                <span style="width: 100%">{{ item.empleado_nombres }}</span>
              </template>

              <template v-slot:item.puesto="{ item }">
                <span style="width: 100%">{{ item.puesto }}</span>
              </template>

              <template v-slot:item.centro_costos="{ item }">
                <span style="width: 100%">{{ item.centro_costos }}</span>
              </template>

              <template v-slot:item.modalidad="{ item }">
                <span style="width: 100%">{{ item.modalidad }}</span>
              </template>

              <template v-slot:item.remuneracion="{ item }">
                <span>{{ item.remuneracion }}</span>
              </template>

              <template v-slot:item.dias_laborales="{ item }">
                <v-text-field
                  v-if="item.estado == true"
                  v-model="item.dias_laborales"
                  :value="item.dias_laborales"
                  outlined
                  type="number"
                  hide-details
                  v-on:keyup.prevent="calculaPagarDiasLab(item)"
                >
                </v-text-field>
                <span v-else>{{ item.dias_laborales }}</span>
              </template>

              <template v-slot:item.valor_dia="{ item }">
                <span>{{ item.valor_dia }}</span>
              </template>

              <template v-slot:item.monto_pagar_laborales="{ item }">
                <span>{{ item.monto_pagar_laborales }}</span>
              </template>

              <template v-slot:item.horas_extra="{ item }">
                <v-text-field
                  v-if="item.estado == true"
                  v-model="item.horas_extra"
                  :value="item.horas_extra"
                  outlined
                  type="number"
                  hide-details
                  v-on:keyup.prevent="calculaPagarHorasLab(item)"
                >
                </v-text-field>
                <span v-else>{{ item.horas_extra }}</span>
              </template>

              <template v-slot:item.valor_hExtra="{ item }">
                <span>{{ item.valor_hExtra }}</span>
              </template>

              <template v-slot:item.monto_pagar_hExtra="{ item }">
                <span>{{ item.monto_pagar_hExtra }}</span>
              </template>

              <template v-slot:item.monto_diasLab_hExtra="{ item }">
                <span>{{ item.monto_diasLab_hExtra }}</span>
              </template>

              <template v-slot:item.totalDescuento="{ item }">
                <span
                  @click="modalDescuentos(item)"
                  v-if="item.estado == true"
                  style="cursor:pointer"
                  >{{ item.totalDescuento }}</span
                >
                <span v-else>{{ item.totalDescuento }}</span>
              </template>

              <template v-slot:item.totalBonos="{ item }">
                <span
                  @click="modalBonos(item)"
                  v-if="item.estado == true"
                  style="cursor:pointer"
                  >{{ item.totalBonos }}</span
                >
                <span v-else>{{ item.totalBonos }}</span>
              </template>

              <template v-slot:item.monto_regimen="{ item }">
                <span>{{ item.monto_regimen }} %</span>
              </template>

              <template v-slot:item.monto_regimen="{ item }">
                <span>{{ item.monto_regimen }} %</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <listar-bonos ref="ListarBonos"></listar-bonos>
    <crear-descuento ref="CrearDescuento"></crear-descuento>
    <pagar ref="Pagar"></pagar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../components/auth/OfficeLogin";
import ArrayTools from "../../helpers/ArrayTools";
import ListarBonos from "../../components/planillas/ListarBonos";
import CrearDescuento from "../../components/planillas/CrearDescuento";
import Pagar from "../../components/planillas/Pagar";
import router from "@/router/index";

export default {
  name: "Employees",
  components: {
    OfficeLogin,
    ListarBonos,
    CrearDescuento,
    Pagar,
  },
  data() {
    return {
      cerrado: false,
      anio: null,
      nombre_mes: null,
      search: "",
      headers: [
        {
          text: "APELLIDOS",
          value: "empleado_apellidos",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "NOMBRES",
          value: "empleado_nombres",
          sortable: false,
          align: "center",
          width: 150,
        },
        { text: "PUESTO", value: "puesto", sortable: false },
        {
          text: "CENTRO DE COSTOS",
          value: "centro_costos",
          sortable: false,
          align: "center",
          width: 150,
        },
        { text: "MODALIDAD", value: "modalidad", sortable: false },
        {
          text: "REMUNERACION COMPUTABLE",
          value: "remuneracion",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "DÍAS LABORALES",
          value: "dias_laborales",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "VALOR DÍA",
          value: "valor_dia",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "MONTO A PAGAR POR DÍAS LABORADOS",
          value: "monto_pagar_laborales",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "HORAS EXTRAS",
          value: "horas_extra",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "VALOR H. EXTRA",
          value: "valor_hExtra",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "TOTAL A PAGAR POR HORAS EXTRAS",
          value: "monto_pagar_hExtra",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "TOTAL DÍAS LABORALES + HORAS EXTRAS",
          value: "monto_diasLab_hExtra",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "DESCUENTO",
          value: "totalDescuento",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "SEGURO SOCIAL",
          value: "sistemaSalud",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "DESCUENTO SEGURO SOCIAL",
          value: "totalSistemaSalud",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "BONOS",
          value: "totalBonos",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "REGIMEN PENSIONARIO",
          value: "nombre_regimen",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "PORCENTAJE REGIMEN PENSIONARIO",
          value: "monto_regimen",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "MONTO REGIMEN PENSIONARIO",
          value: "monto_descRegimen",
          sortable: false,
          align: "center",
          width: 150,
        },
        {
          text: "TOTAL A PAGAR",
          value: "totalPagar",
          sortable: false,
          align: "center",
          width: 150,
        },
      ],
      estado: null,
      search_employee: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      id_planilla: null,
      itemsBreadcrumbs: [
        {
          text: "Planillas",
          disabled: true,
          href: "",
        },
      ],
      newArray: [],
      total: 0.0,
      is_download: false,
    };
  },
  computed: {
    ...mapState("employees", ["employees"]),
    ...mapState("planillaDetalle", ["itemsPlanilla", "file_planillaDetalle"]),
    ...mapState("bonos", ["bonoActivo"]),
  },
  methods: {
    ...mapActions("employees", ["getEmployees", "change_status", "delete"]),
    ...mapActions("offices", ["getAvailables"]),
    ...mapActions("roles", ["getRoles"]),
    ...mapActions("planillaDetalle", [
      "getItems",
      "guardaCierra",
      "calculaCierra",
      "reabrirPlanilla",
      "planillaDownload",
      "actualizarPlanilla",
    ]),
    ...mapActions("planillas", ["getPlanillas"]),

    ...mapActions("bonos", ["bonoActivos"]),
    async descargaReporte() {
      this.is_download = true;
      // let nameReporte =
      //   "planilla-" + this.nombre_mes + "-" + this.anio + ".xlsx";
      // console.log('aqui se genera la planilla')
      // console.log(nameReporte)//this.emptyFileSales();
      //let filters_data = Object.assign({}, this.filters);
      //filters_data.company_id = this.company_id;
      await this.planillaDownload(this.id_planilla);
      this.is_download = false;
      if (this.file_planillaDetalle) {
        let url =
          process.env.VUE_APP_API_URL_BASE + "/" + this.file_planillaDetalle;
        window.open(url);
      }
    },
    async muetsrameYa() {
      await this.getItems(this.identificador);
    },
    async reabrirPlanillaBtn() {
      await this.reabrirPlanilla(this.newArray);
      await this.getPlanillas();
      router.push("/app/planillas/planillas-Info");
    },
    modalPagar() {
      this.$refs.Pagar.showForm("Pagar Planilla", this.total);
    },
    async calcularCerrarBtn() {
      await this.calculaCierra(this.newArray);
      await this.getPlanillas();
      router.push("/app/planillas/planillas-Info");
    },
    async guardaCierraBtn() {
      await this.guardaCierra(this.newArray);
      router.push("/app/planillas/planillas-Info");
    },
    async actualizarBtn() {
      this.id_planilla = parseInt(localStorage.getItem("id_planilla"));
      await this.actualizarPlanilla(this.id_planilla);
      // this.newArray = ;
      this.calcularBono(this.itemsPlanilla);
      // this.getAllEmployees();
    },

    modalDescuentos(item) {
      this.$refs.CrearDescuento.showForm("Descuentos", item, this.total);
      this.totalPlanilla();
    },
    modalBonos(item) {
      this.$refs.ListarBonos.showForm("Bonos", item);
    },
    totalPlanilla() {
      this.total = 0;
      this.newArray.forEach((element) => {
        let auxTotal = parseFloat(this.total) + parseFloat(element.totalPagar);
        this.total = parseFloat(auxTotal).toFixed(2);
      });
    },
    calculaPagarDiasLab(item) {
      // console.log(":::::",item);
      if (item.dias_laborales < 0) item.dias_laborales = 0;
      item.monto_diasLab_hExtra = 0;
      item.monto_descRegimen = 0;
      // item.totalSistemaSalud = 0;
      if (item.dias_laborales < 7) {
        let auxPagarLab = item.valor_dia * parseFloat(item.dias_laborales);
        item.monto_pagar_laborales = parseFloat(auxPagarLab).toFixed(2);
      } else if (item.dias_laborales >= 7 && item.dias_laborales < 12) {
        let auxPagarLab =
          item.valor_dia * (parseFloat(item.dias_laborales) + 1);
        item.monto_pagar_laborales = parseFloat(auxPagarLab).toFixed(2);
      } else if (item.dias_laborales >= 12 && item.dias_laborales < 18) {
        let auxPagarLab =
          item.valor_dia * (parseFloat(item.dias_laborales) + 2);
        item.monto_pagar_laborales = parseFloat(auxPagarLab).toFixed(2);
      } else if (item.dias_laborales >= 18 && item.dias_laborales < 24) {
        let auxPagarLab =
          item.valor_dia * (parseFloat(item.dias_laborales) + 3);
        item.monto_pagar_laborales = parseFloat(auxPagarLab).toFixed(2);
      } else if (item.dias_laborales >= 24 && item.dias_laborales < 26) {
        let auxPagarLab =
          item.valor_dia * (parseFloat(item.dias_laborales) + 4);
        item.monto_pagar_laborales = parseFloat(auxPagarLab).toFixed(2);
      } else if (item.dias_laborales == 26) {
        item.monto_pagar_laborales = parseFloat(item.remuneracion).toFixed(2);
      } else if (item.dias_laborales > 26) {
        let auxPagarLab =
          item.valor_dia * (parseFloat(item.dias_laborales) + 4);
        item.monto_pagar_laborales = parseFloat(auxPagarLab).toFixed(2);
      }

      let suma =
        parseFloat(item.monto_diasLab_hExtra) +
        parseFloat(item.monto_pagar_laborales) +
        parseFloat(item.monto_pagar_hExtra);
      item.monto_diasLab_hExtra = suma;

      let porcentaje = (item.monto_diasLab_hExtra * item.monto_regimen) / 100;
      item.monto_descRegimen = parseFloat(porcentaje).toFixed(2);

      // if (item.sistemaSalud == "ESSALUD") {
      //   let montoSeguro = item.monto_diasLab_hExtra * 0.09 -  parseFloat(item.monto_seguro_empresa);
      //   // console.log(item.monto_diasLab_hExtra)
      //   // console.log(item.monto_seguro_empresa)
      //   // console.log(item.montoSeguro)
      //   item.totalSistemaSalud = parseFloat(montoSeguro).toFixed(2);
      // } else {
      //   item.totalSistemaSalud = 0.0;
      // }
      console.log(item);
      // let total = parseFloat(item.monto_diasLab_hExtra) +  parseFloat(item.totalBonos) -  (parseFloat(item.totalSistemaSalud) +  parseFloat(item.monto_descRegimen) + parseFloat(item.totalDescuento));
      //let total = parseFloat(item.monto_diasLab_hExtra) +  parseFloat(item.totalBonos) -  (parseFloat(item.totalSistemaSalud) +  parseFloat(item.monto_descRegimen) + parseFloat(item.totalDescuento));
      let total =
        parseFloat(item.monto_diasLab_hExtra) +
        parseFloat(item.totalBonos) -
        (parseFloat(item.monto_descRegimen) + parseFloat(item.totalDescuento));

      item.totalPagar = total.toFixed(2);
      this.totalPlanilla();
    },
    calculaPagarHorasLab(item) {
      if (item.horas_extra < 0) item.horas_extra = 0;
      item.monto_diasLab_hExtra = 0;
      item.monto_descRegimen = 0;
      let extra = parseFloat(item.valor_hExtra) * parseFloat(item.horas_extra);
      item.monto_pagar_hExtra = parseFloat(extra).toFixed(2);
      let suma =
        parseFloat(item.monto_diasLab_hExtra) +
        parseFloat(item.monto_pagar_laborales) +
        parseFloat(item.monto_pagar_hExtra);
      item.monto_diasLab_hExtra = parseFloat(suma).toFixed(2);
      let porcentaje = (item.monto_diasLab_hExtra * item.monto_regimen) / 100;
      item.monto_descRegimen = parseFloat(porcentaje).toFixed(2);
      if (item.sistemaSalud == "ESSALUD") {
        let montoSeguro =
          item.monto_diasLab_hExtra * 0.09 -
          parseFloat(item.monto_seguro_empresa);
        item.totalSistemaSalud = parseFloat(montoSeguro).toFixed(2);
      } else {
        item.totalSistemaSalud = 0.0;
      }
      let total =
        parseFloat(item.monto_diasLab_hExtra) +
        parseFloat(item.totalBonos) -
        (parseFloat(item.totalSistemaSalud) +
          parseFloat(item.monto_descRegimen) +
          parseFloat(item.totalDescuento));
      item.totalPagar = total.toFixed(2);
      // console.log(item)
      this.totalPlanilla();
    },
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo empleado", "create");
    },
    handleEdit() {
      let employee = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de empleado",
        "update",
        employee
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de empleados");
    },
    async getAllEmployees() {
      this.nombre_mes = localStorage.getItem("nombre_mes");
      this.anio = localStorage.getItem("anio");
      this.newArray = this.itemsPlanilla;
      if (this.itemsPlanilla.length > 0) {
        this.cerrado = this.itemsPlanilla[0].estado;
      }
      this.estado = true;
      this.id_planilla = parseInt(localStorage.getItem("id_planilla"));
      // console.log(this.id_planilla)
      await this.getItems(this.id_planilla);
      await this.getEmployees();
      this.totalPlanilla();
      await this.bonoActivos();
      // ! calcular los bonos
      this.calcularBono(this.newArray);
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        fullname: this.search_employee,
      };
      await this.getEmployees(filters);
    },
    async handleChangeStatus() {
      let employee = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(employee);
    },
    async handleDelete() {
      let employee = this.selectedRows[0];
      await this.delete(employee);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    calcularBono(newArray) {
      let newArrayAux = [];
      newArray.forEach((element) => {
        let count = 0;
        if (element.bonos != null) {
          JSON.parse(element.bonos).forEach((value) => {
            if (value) {
              count = count + parseInt(value.monto);
            }
          });
          element.totalBonos = count;
        }
        newArrayAux.push(element);
      });
      this.newArray = newArrayAux;
    },
  },
  created() {
    this.getAllEmployees();
    this.getAvailables();
    this.getRoles();
  },
};
</script>

<style scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 5px;
}
.v-data-table th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 0.75rem;
  height: 75px !important;
}
.text-center {
  height: 75px !important;
}
</style>
